import React from 'react'
import styles from './InformationDisplay.module.scss'

// infoList 구조
// [{label : value}, {label : value} ...]

const InformationDisplay = ({ infoList }) => {
	return (
		<>
			{infoList.map(({ label, value }) => (
				<React.Fragment key={label}>
					<div className={styles.label}>{label}</div>
					<div className={styles.displayBox}>{value}</div>
				</React.Fragment>
			))}
		</>
	)
}

export default InformationDisplay
